<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="mx-auto">
    <component :is="'style'">
      :root { --selectText: "{{ $t('common.chooseFileBtn') }}";}
    </component>
    <div class="form-section">
      <h4 class="text-header form-section__title">
        <span
          v-for="(item, index) in $root.t('step3.uploadDocument')"
          :key="index"
        >
          {{ item }} <br>
        </span>
      </h4>
      <p class="form-section__description">
        <span
          v-for="(item, index) in $root.t('step3.uploadDocumentDesc1')"
          :key="index"
        >
          {{ item }} <br>
        </span>
      </p>
      <p class="form-section__description">
        <span
          v-for="(item, index) in $root.t('step3.uploadDocumentDesc2')"
          :key="index"
        >
          {{ item }} <br>
        </span>
      </p>

      <div class="row">
        <!-- Document file -->
        <div class="col-md-8 mb-3">
          <div
            v-for="(document, index) in documents"
            :key="index"
            class="col-md-12 file-upload"
          >
            <div v-if="isAllowUploadFile(document)">
              <div class="d-flex justify-start">
                <label class="required me-1" />
                <label
                  class="form-label"
                  :for="`files-${getDocumentName(document.name)}-${memberIndex}-${index}`"
                  v-html="document.name"
                />
              </div>
			  
              <div
                v-if="currentLocale != 'en'"
                class="d-flex justify-start"
              >
                <span class="required me-1" />
                <span
                  class="form-label"
                  v-html="document.nameTranslation"
                />
              </div>

              <b>{{ document.fileName ? ' (' + document.fileName + ')' : '' }}</b>

              <div class="col-sm-10">
                <div class="input-group custom-file-button">
                  <label
                    class="input-group-text"
                    :for="`${getDocumentName(document.name)}_${document.postfix}`"
                  >{{ $t('common.chooseFileBtn') }}</label>
                  <input
                    :id="`${getDocumentName(document.name)}_${document.postfix}`"
                    :name="document.name"
                    aria-label="Upload document"
                    class="form-control custom-file-input"
                    :accept="acceptFiles"
                    type="file"
                    :title="$t('common.chooseFileBtn')"
                  >
                </div>
              </div>

              <ValidationProvider
                v-slot="v"
                rules="required"
              >
                <input
                  type="text"
                  :value="document.fileName"
                  disabled
                  class="hidden"
                >
                <span
                  v-if="v.validated && v.invalid"
                  class="input-error"
                  v-html="v.errors[0]"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
        <!-- How to upload docs -->
        <div class="col-md-4 mb-3">
          <div
            v-for="(item, index) in $root.t('step3')"
            :key="index"
          >
            {{ item.uploadDocumentTutorial }}
            <ul style="list-style: decimal">
              <li>{{ item.uploadDocumentStep1 }}</li>
              <li>{{ item.uploadDocumentStep2 }}</li>
              <li>{{ item.uploadDocumentStep3 }}</li>
            </ul>
            <br>
          </div>
        </div>
      </div>

      <LoadingButton
        :id="'uploadFile'"
        :title="$t('common.uploadFilesBtn')"
        :class-name="'mt-3'"
        :is-loading="isNextBtnLoading"
        @onClick="uploadFiles()"
      />
    </div>
  </div>
</template>
<script>

import baseApi from '../../api/common/baseApi.js'
import LoadingButton from '../shared/LoadingButton.vue'
import helper from '../../utils/helper.js'

export default {
  name: 'DocumentUpload',
  components: {
    LoadingButton,
  },
  props: {
    memberIndex: { type: Number, default: null },
    documents: { type: Array, default: () => [] },
	lists: {type: Array, default: () => []}
  },
  data() {
    return {
      acceptFiles: '.pdf,.docx,.doc,.rtf,.bmp,.gif,.jpg,.jpeg,.png',
      isNextBtnLoading: false,
      emptyFile: 0,
      ref: null,
	  selectText: 'Choose file',
	  currentLocale: this.$locale,
	  globalDocument: this.documents
    }
  },
  computed: {
    fileUploadEmptyErrorMessage() {
		return helper.multiLanguageDisplay(this.$root.t('notify.fileUploadEmpty'))
	},

	fileUploadSuccessMessage() {
		return helper.multiLanguageDisplay(this.$root.t('notify.fileUploadSuccess'))
	}
  },
  mounted() {},
  methods: {
    async uploadFiles() {
      this.isNextBtnLoading = true
      let fileInputs = this.$el.querySelectorAll(`input[type='file']`)
      let fileCount = 0
      const formData = new FormData()

      fileInputs.forEach((input) => {
        const files = input.files
        if (files.length == 0) {
          return
        }

        Array.from(files).forEach((file) => {
          fileCount++
          let extension = file.name.substring(file.name.lastIndexOf('.'), file.name.length)
          let fileName = input.id + extension
          let documentName = input.name
          let document = this.documents.find((i) => i.name == documentName)
          if (document) {
            document.willUploadFileName = file.name
          }

          formData.append('files', file, fileName)
          formData.append('formDataId', this.$formData.id)
        })
      })

      if (fileCount == 0) {
        this.$toast.open({
          message: this.fileUploadEmptyErrorMessage,
          type: 'error',
        })
      } else {
        try {
          await baseApi.uploadFiles('api/files', formData)
          this.documents.forEach((doc) => {
            doc.fileName = doc.willUploadFileName
          })

          this.$toast.open({
            message: this.fileUploadSuccessMessage,
            type: 'success',
          })
        } catch (e) {
          if (e) {
            console.error('upload file error: ', e)
            this.$toast.open({
              message: e,
              type: 'error',
            })
          }
        }
      }

      this.isNextBtnLoading = false
    },

    isAllowUploadFile(document) {
      if (document.appliesToJustPolicyHolder) {
        return this.memberIndex == null // memberIndex == null => Policy holder
      }

      return !document.appliesToJustPolicyHolder
    },

    getDocumentName(rawDocumentName) {
      // split get document name
      let lowerDocumentName = rawDocumentName.toLowerCase().split('<br>')
      if (lowerDocumentName 
            && lowerDocumentName[0]
                .startsWith('Proof of Address'
                  .toLowerCase())) {
        return 'Proof_Of_Address'
      }

      return 'Proof_Of_Identity'
    },
  },
}
</script>

<style lang="scss" scoped>
	.file-upload {
		margin-bottom: 1.5rem !important;

		&:last-child {
			margin-bottom: 0 !important;
		}
	}

	.custom-file-button {
		input[type="file"] {
			margin-left: -2px !important;

			&::-webkit-file-upload-button {
				display: none;
			}
			&::file-selector-button {
				display: none;
			}
		}

		&:hover {
			label {
				background-color: #dde0e3;
				cursor: pointer;
			}
		}
	}

</style>
